import Vue, { CreateElement, VNode, VNodeData } from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import './tabItem.styl';

@Component({
  name: 'TabsItem',
})
export default class TabsItem extends Vue {
  @Prop(String) public readonly name;
  @Prop(Object) public readonly link;
  @Prop(Boolean) public readonly active;

  private render(createElement: CreateElement): VNode {
    const data: VNodeData = {
      class: {
        'tab-active': this.active,
        'tabs': true,
        button: true,
      },
      domProps: {
        innerHTML: this.name,
      },
      props: {
        to: {
          name: this.link.name,
        },
      },
    };

    const dataLine: VNodeData = {
      class: {
        'tab-active__underline': this.active,
        'tabs-item': true,
      },
    };


    return createElement('div', [createElement('router-link', data), createElement('span', dataLine)]);
  }
}
